import {
  debounce,
  Dialog,
  DialogContent,
  Grid2,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { IconUser, IconX } from "@tabler/icons-react";
import { useMutation, useQuery } from "@tanstack/react-query";
import Loading from "./Loading";
import { useState } from "react";
import { studentsList } from "../services/students";
import { Input } from "./Input";
import { toast } from "react-toastify";
import { classesCheckInStore } from "../services/classes";

const StudentsList = ({
  id,
  open,
  onClose,
  refetch,
  frequency = [],
}: {
  id: number;
  open: boolean;
  onClose: () => void;
  refetch: () => void;
  frequency: any;
}) => {
  const [search, setSearch] = useState("");

  const {
    data,
    isLoading,
    isFetching,
  }: {
    data: any;
    isLoading: boolean;
    isFetching: boolean;
  } = useQuery({
    queryKey: ["getStudent-" + search],
    queryFn: async () => await studentsList({ search }),
    initialData: [],
  });

  const { mutate, isPending } = useMutation({
    mutationFn: classesCheckInStore,
    onSuccess: () => {
      onClose();
      refetch();
      toast.success("Aula atualizada com sucesso");
    },

    onError: (e: { response: { data: { message: string } } }) => {
      toast.error(String(e?.response?.data?.message) || "Erro!");
    },
  });

  return (
    <Dialog maxWidth="xs" open={open} onClose={() => onClose()}>
      <Loading loading={isLoading || isFetching || isPending} />
      <DialogContent sx={{ backgroundColor: "secondary.main" }}>
        <Grid2 container spacing={2} padding={1}>
          <Grid2 size={{ xs: 10, md: 11 }}>
            <Typography variant="h2" fontSize={26} fontWeight={600}>
              Alunos
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 2, md: 1 }}>
            <IconButton onClick={() => onClose()}>
              <IconX style={styles.iconStyle} />
            </IconButton>
          </Grid2>
          <Grid2 size={12}>
            <Input
              id="search"
              name="search"
              placeholder="Pesquise aqui"
              type="text"
              fullWidth
              size="small"
              onChange={debounce((v) => {
                setSearch(v?.target?.value);
              }, 500)}
            />
          </Grid2>
          <Grid2 size={12}>
            <Stack spacing={2}>
              {data
                ?.filter(
                  (i: any) =>
                    !frequency?.map((f: any) => f.studentId).includes(i.id)
                )
                .map((item: any) => (
                  <Stack
                    key={item?.id}
                    sx={{
                      flexDirection: "row",
                      alignItems: "center",
                      paddingY: 1,
                      paddingX: 2,
                      borderRadius: 4,
                      backgroundColor: "secondary.dark",
                      gap: 1,
                      cursor: "pointer",
                      "&:hover": {
                        scale: 0.875,
                      },
                    }}
                    onClick={() => mutate({ id, studentId: item?.id })}
                  >
                    <IconUser size={18} />
                    <Typography>{item?.fullName}</Typography>
                  </Stack>
                ))}
            </Stack>
          </Grid2>
        </Grid2>
      </DialogContent>
    </Dialog>
  );
};

const styles = {
  stackStyle: {
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    padding: 1,
    borderRadius: 2,
    backgroundColor: "secondary.dark",
  },
  iconStyle: {
    color: "primary.main",
  },
};

export default StudentsList;
